var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contentContainer",staticStyle:{"background":"#fff","padding-left":"0","padding-right":"0"}},[_c('MediaDatatable',{ref:"mediaDatatable",attrs:{"mediaId":_vm.mediaId,"mediaType":_vm.mediaType}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }